<template>
    <div class="div">
        <div class="d-flex slider-livro" :style="`min-height: 700px;`">
            <div class="container">

                <div class="row d-flex justify-content-center">
                    <h2 class="text-white font-glacial-regular ebook-titulo" :style="`margin-bottom: 20px;`">
                        {{data.titulo}}
                    </h2>
                </div>

                <div class="row d-flex justify-content-center">
                    <div class="col-12 col-xl-10">
                        <h2 class="text-white font-glacial-regular text-center ebook-subtitulo">
                            {{data.descricao}}
                        </h2>
                    </div>
                </div>

                <div ref="observerLivros"></div>
                <transition enter-active-class="animated fadeInUp">
                    <div v-if="showObserver">
                        <div v-for="(d, i) in posts" :key="i" v-if="index == i">
                            <div class="d-flex justify-content-center slider-livro-content mb-5" >
                                <div class=" btn-left-padding d-lg-flex d-none align-items-center justify-content-center">
                                    <div class="btn-left-white align-self-center" @click="btnLeft">
                                    </div>
                                </div>
                                <div v-b-modal.modalPrevent @click="openPDF(d)" class="row col-xl-10 col-12 d-flex justify-content-center">
                                    <div class="col-12 col-lg-5 justify-content-end slider-livro-align">
                                        <h2 class="font-glacial-bold text-white text-center animated fadeInLeft">
                                            {{d.title.rendered}}
                                        </h2>
                                        <h3 class="font-glacial-regular text-white animated fadeInLeft">
                                            {{d.content.rendered}}
                                        </h3>
                                        <div v-b-modal.modalPrevent @click="openPDF(d)" class="btn-baixar-ebook animated fadeInUp"></div>
                                    </div>
                                    <div class="col-12 col-lg-5 d-flex justify-content-center">
                                        <div class="capa-livro shadow-video animated fadeInRight" :style="`background-image: url(${d.better_featured_image.source_url})`">
                                        </div>
                                    </div>
                                </div>
                                <div class=" btn-right-padding d-lg-flex d-none align-items-center justify-content-center">
                                    <div class="btn-right-white d-flex justify-content-end" @click="btnRight">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6 btn-left-padding d-flex align-items-center justify-content-center d-lg-none">
                                    <div class="btn-left-white align-self-center" @click="btnLeft">
                                    </div>
                                </div>
                                <div class="col-6 btn-right-padding d-flex align-items-center justify-content-center d-lg-none">
                                    <div class="btn-right-white d-flex justify-content-end" @click="btnRight">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

            </div>
        </div>

        <b-modal hide-footer hide-header centered id="modalPrevent" ref="modal" class="livros-modal-body">
            <div >

                <div class="row justify-content-center pb-4"> 
                    <div class="col-12">

                        <label class="text-white pt-4">NOME</label>
                        <div class="input-group">
                            <b-form-input v-model="form.nome"
                                        type="text"
                                        placeholder="Nome">
                            </b-form-input>
                            <!-- <div class="text-center height-0">
                                {{showError('nome')}}
                            </div> -->
                        </div>
                        <div class="pt-2">
                            <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors && errors.nome">
                                {{errors.nome[0]}}
                            </b-alert>
                        </div>

                        <label class="text-white pt-4">E-MAIL</label>
                        <div class="input-group">
                            <b-form-input v-model="form.email"
                                        type="text"
                                        placeholder="E-Mail">
                            </b-form-input>
                            <!-- <div class="text-center height-0">
                                {{showError('email')}}
                            </div> -->
                        </div>
                        <div class="pt-2">
                            <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors && errors.email">
                                {{errors.email[0]}}
                            </b-alert>
                        </div>

                        <label class="text-white pt-4">Celular</label>
                        <div class="input-group">
                            <b-form-input v-model="form.whatsapp"
                                        v-mask="'(##) #####-####'"
                                        type="tel"
                                        placeholder="Número Celular">
                            </b-form-input>
                            <!-- <div class="text-center height-0">
                                {{showError('telefone')}}
                            </div> -->
                        </div>
                        <div class="pt-2">
                            <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors && errors.whatsapp">
                                {{errors.whatsapp[0]}}
                            </b-alert>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-6">
                        <div class="pt-4 mb-3 input-group">
                            <b-btn class="btn btn-baixar btn-pointer" @click="submit()" :disabled="loading"></b-btn>
                        </div>
                    </div>
                </div>

                <b-alert show variant="success" v-if="success">
                    {{success}}
                </b-alert>
                <!-- <div class="text-center height-0" v-if="showError('nome')">
                    {{showError('nome')}}
                </div>
                <b-alert show variant="warning mt-3 mt-xl-0" v-if="errors">
                    {{errors}}
                </b-alert>
                <div class="text-center height-0" v-if="showError('email')">
                    {{showError('email')}}
                </div> -->
            </div>
        </b-modal>

    </div>
</template>
<script>
import observer from 'intersection-observer';

export default {
    props:{
        data: null
    },
    data(){
        return{
            success: null,
            posts: null,
            showObserver: false,
            show: false,
            showModal: false,
            index: 0,
            total: 0,
            errors: null,
            loading: false,
            linkPDF: '',
            form: {
                nome: '',
                email: '',
                whatsapp: '',
                id_ebook: '',
                ebook: '',
            },
            link: '',
        }
    },

    mounted(){
        var observer = new IntersectionObserver((entries) => {
            // If intersectionRatio is 0, the target is out of view
            // and we do not need to do anything.
            if (entries[0].intersectionRatio <= 0) {
                return;
            }
            this.showObserver = true
            observer.unobserve(this.$refs.observerLivros)
        });
        observer.POLL_INTERVAL = 100;
        observer.observe(this.$refs.observerLivros)
    },

    created() {
        this.loadMore();
    },

    methods:{
        openPDF(d) {
            this.form.linkPDF = d.acf.ebook.url
            this.form.ebook = d.acf.ebook.title
            this.form.id_ebook = d.acf.ebook.ID
        },
        showError(field){
            if(this.errors && this.errors.invalidFields){
                for (let index = 0; index < this.errors.invalidFields.length; index++) {
                    const e = this.errors.invalidFields[index];

                    if (e.into.includes(field)){
                        return e.message
                    }
                }
            }
            return null;
        },

        loadMore(){
            this.page++

            this.loading = true

            var url = window.SETTINGS.API_BASE_PATH + "posts?_embed&categories=3&per_page=3"
            axios.get(url).then(response => {
                this.total = response.data.length
                this.posts = response.data.sort((o, i) => Math.random() - Math.random());
                this.loading = false
            })
        },

        async serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },

        async submit(pdf, titulo){
            // if(this.form.nome == ''){
            //     return this.errors = 'O nome é obrigatório.';
            // }

            // if(this.form.email == ''){
            //     return this.errors = 'O e-mail é obrigatório.';
            // }

            // if(this.form.whatsapp == ''){
            //     return this.errors = 'O número de celular é obrigatório';
            // }
            if(this.success){
                return
            } 

            this.loading = true
            this.errors = null

            //Após a verificação se deu retorno 1, ai sim abrir o pdf para ser baixado e não antes.
            
            var query = await this.serialize(this.form);

            var id=365;

            try {
                // axios.post(`/wp-json/contact-form-7/v1/contact-forms/${id}/feedback`, formData).then(response => {
                
                var response = await axios.get(`http://manager.escolabauhaus.com.br/saveleadebook/?` + query, this.form)
                if(response.data == '1' && response.status == '200'){
                    window.open(this.form.linkPDF, '_blank'); //Abre em um nova página
                    this.form.nome = ''
                    this.form.email = '' 
                    this.form.whatsapp = '' 
                    this.form.ebook = '' 
                    this.form.id_ebook = '' 
                    this.$refs.modal.hide()
                } else {
                    // this.errors = response.data.statusText
                    this.errors = response.data

                    if(this.errors.nome[0] == ''){
                        this.loading = false
                        return this.errors = this.errors.nome[0];
                    }

                    if(this.errors.email[0] == ''){
                        this.loading = false
                        return this.errors = this.errors.email[0];
                    }

                    if(this.errors.whatsapp[0] == ''){
                        this.loading = false
                        return this.errors = this.errors.whatsapp[0];
                    }
                }
            } catch (e) {
                console.log(e)
            }
            this.loading = false
        },

        btnRight(){
            if(this.index >= (this.total - 1)){
                this.index = 0
            } else {
                this.index++
            }
        },

        btnLeft(){
            if(this.index < 1){
                this.index = (this.total - 1)
            } else {
                this.index--
            }
        },

        handleOk (evt) {
            // Prevent modal from closing
            evt.preventDefault()
            if (!this.name) {
                alert('Please enter your name')
            } else {
                this.handleSubmit()
            }
        },

        handleSubmit () {
            this.names.push(this.name)
            this.name = ''
            this.$refs.modal.hide()
        },

    }
}
</script>




// WEBPACK FOOTER //
// src/components/widgets/slider_livros.vue